module.exports = __webpack_public_path__ + "static/media/filter-feature-pets.3f39c370.svg";